import { NextSeo } from 'next-seo';

import placeholder from 'lib/placeholder';

const Head = () => (
  <>
    <NextSeo
      description={placeholder('seo.myBlackFriday.description')}
      openGraph={{
        title: placeholder('seo.myBlackFriday.title'),
        description: placeholder('seo.myBlackFriday.description'),
      }}
      title={placeholder('seo.myBlackFriday.title')}
    />
  </>
);

export default Head;
